import { render, staticRenderFns } from "./CSVupload.vue?vue&type=template&id=74456fd5&scoped=true"
import script from "./CSVupload.vue?vue&type=script&lang=js"
export * from "./CSVupload.vue?vue&type=script&lang=js"
import style0 from "./CSVupload.vue?vue&type=style&index=0&id=74456fd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74456fd5",
  null
  
)

export default component.exports